package com.essntl.uikit.components.link

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.uikit.components.button.EsButton
import com.essntl.uikit.components.button.EsButtonColors
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.theme.EsColorScheme
import com.essntl.uikit.theme.esColorScheme

@Composable
fun NavLinkItem(
    item: NavLinkState,
    onClick: () -> Unit,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme

    EsButton(
        onClick = {
            if (enabled) onClick()
        },
        size = EsButtonSize.Small,
        colors = getNavLinkButtonColors(essntlColorScheme),
        text = if (item.isLoading) "" else item.title,
        prefixIconRes = item.iconRes,
        prefixIconUrl = item.iconUrl,
        loading = item.isLoading,
        modifier = modifier,
    )
}


internal fun getNavLinkButtonColors(esColorScheme: EsColorScheme) = EsButtonColors(
    containerColor = esColorScheme.bgPrimary,
    disabledContainerColor = esColorScheme.bgPrimary,
    pressedContainerColor = esColorScheme.ghostPressed.copy(alpha = .8f),
    hoveredContainerColor = esColorScheme.ghostPressed,
    focusedContainerColor = esColorScheme.bgPrimary,
    textColor = esColorScheme.textPrimary,
    disabledTextColor = esColorScheme.textDisabled,
    iconColor = esColorScheme.iconPrimary,
    disabledIconColor = esColorScheme.iconDisabled,
    borderFocusColor = esColorScheme.bgPrimary,
)